import type { ICellRendererParams } from 'ag-grid-enterprise'

import { Badge } from '@fortem-monorepo/react-ui'
import type { AccruedInterests } from '@fortem-monorepo/web-sdk'

import type { AccrualCheck } from '../accrual-check'

export const RecentTradeCell = ({ value }: ICellRendererParams<AccruedInterests.DailyRow, number>) => {
  if (!value || value <= 0) return null
  return <Badge theme="success">NEW</Badge>
}

export const AccrualCheckCell = ({ value }: ICellRendererParams<AccruedInterests.DailyRow, AccrualCheck>) => {
  if (!value) return null
  return <Badge theme={value === 'In Line' ? 'success' : value === 'Minor' ? 'warning' : 'destructive'}>{value}</Badge>
}
